import React, {useCallback, useEffect, useMemo, useState, useRef} from 'react'
import {useLocation, useHistory} from 'react-router-dom'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalBody,
    Box,
    Text,
    IconButton,
    ModalHeader,
    Heading,
    HStack,
    Tooltip,
    Button,
    Img,
    useBreakpointValue,
    Flex,
    VStack,
    Stack
} from '@chakra-ui/react'
import {MinusIcon, AddIcon} from '@chakra-ui/icons'
import {useIntl} from 'react-intl'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import CloudinaryImageGallery from '../../../../cloudinary/cloudinary-image-gallery'
import LoadingSpinner from '../../../../components/loading-spinner'
import {
    useAccessToken,
    useCustomerId,
    useProduct,
    useShopperBasketsMutation,
    useShopperBasketsMutationHelper,
    useShopperCustomersMutation
} from '@salesforce/commerce-sdk-react'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useDerivedProduct} from '../../../../hooks/use-derived-product'
import {galleryOptionsQuickView} from '../../../../static/constants'
import {pxToRem} from '../../../../utills/pxToRem'
import {
    imageGalleryStyle,
    modalHeaderStyle,
    productDescriptionLayout,
    productTitle,
    modalContentStyle
} from './index.style'
import DisplayPrice from '../../../../components/display-price'
import {
    getPriceData,
    normalizeSetBundleProduct
} from '@salesforce/retail-react-app/app/utils/product-utils'
import {
    addToCartButton,
    priceStyle,
    renderButtons,
    salePriceStyle,
    savingPriceStyle,
    viewLinkStyle,
    wishlistButton,
    wishlistIcon,
    wishlistTooltip
} from '../../../product-detail/index.style'
import Swatch from '../../../../components/swatch-group/swatch'
import SwatchGroup from '../../../../components/swatch-group'
import useSitePreference from '../../../../hooks/use-site-preference'
import {
    buttonContainer,
    calloutBoxStyle,
    containerStyle,
    desktopDetailsStyle,
    flexStyle,
    hStackStyle,
    iconStyle,
    inputStyle,
    minusButtonStyle,
    mobileDetailsStyle,
    plusButtonStyle,
    stockLeftStyle,
    tagIconStyle,
    tooltipStyle,
    colorSwatchStyle
} from '../../../../components/product-view/index.style'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {useToast} from '../../../../hooks/use-toast'
import {
    API_ERROR_MESSAGE,
    TOAST_ACTION_VIEW_WISHLIST,
    TOAST_MESSAGE_ADDED_TO_WISHLIST,
    TOAST_MESSAGE_ALREADY_IN_WISHLIST
} from '@salesforce/retail-react-app/app/constants'
import {CART_LIMIT_ERROR_CODE, CART_FULL_ERROR_MESSAGE} from '../../../../constants'
import {useAddToCartModalContext} from '../../../../hooks/use-add-to-cart-modal'
import useCartLimit from '../../../../hooks/use-cart-limit'
import {useCurrentCustomer} from '@salesforce/retail-react-app/app/hooks/use-current-customer'
import {useWishList} from '../../../../hooks/use-wish-list'
import {useCurrentBasket} from '@salesforce/retail-react-app/app/hooks/use-current-basket'
import useEinstein from '@salesforce/retail-react-app/app/hooks/use-einstein'
import {rebuildPathWithParams} from '@salesforce/retail-react-app/app/utils/url'
import DeliveryAddress from '../../../../components/delivery-address'
import useSizeMappingData from '../../../../utills/getProductSizeMapping'
import useUpdateShopperContext from '../../../../components/store-selector-modal/updateShopperContext'
import CloudinaryImageSwatches from '../../../../cloudinary/cloudinary-image-swatches'
import PropTypes from 'prop-types'
import {useUsid} from '@salesforce/commerce-sdk-react'
import {triggerAddToCartEvent} from '../../../../utills/gtm/triggerAddToCartEvent'
import CartErrorMessage from '../../../../components/CartErrorMessage'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getAdyenPaymentMethods} from '../../../checkout/adyenOverrides/utils/get-adyen-payment-methods'
function QuickView(props) {
    const {
        isOpen,
        onClose,
        product,
        previousSearchParams,
        setSelectedBundleQuantity = () => {},
        updateCart,
        category = null
    } = props
    const intl = useIntl()
    const isTabOrLarger = useBreakpointValue({base: false, md: true})
    const location = useLocation()
    const history = useHistory()
    const {usid} = useUsid()
    const urlParams = new URLSearchParams(location.search)
    const [isPickUpInStore, setIsPickUpInStore] = useState(false)
    const {
        data: productDetail,
        isLoading: isProductLoading,
        isError: isProductError,
        error: productError
    } = useProduct(
        {
            parameters: {
                id:
                    urlParams.get('pid') == null || urlParams.get('pid') == undefined
                        ? product?.productId || product?.id
                        : encodeURIComponent(urlParams.get('pid')),
                perPricebook: true,
                expand: [
                    'availability',
                    'promotions',
                    'options',
                    'images',
                    'prices',
                    'variations',
                    'set_products',
                    'bundled_products'
                ],
                allImages: true,
                c_isPDPRequest: true,
                c_isPickUpInStore: isPickUpInStore,
                locale: 'default'
            }
        },
        {
            keepPreviousData: true,
            enabled: isOpen
        }
    )

    const showError = () => {
        showToast({
            title: intl.formatMessage(API_ERROR_MESSAGE),
            status: 'error'
        })
    }

    const canAddToWishlist = !isProductLoading
    const isProductASet = productDetail?.type?.set
    const isProductABundle = productDetail?.type.bundle

    const QuantityPickerSection = ({
        quantity,
        minOrderQuantity,
        stockLevel,
        setQuantity,
        stepQuantity,
        isVisible = false
    }) => {
        const maxAllowed = Math.min(stockLevel, 10)

        const dec = () =>
            setQuantity((q) => (q - stepQuantity >= minOrderQuantity ? q - stepQuantity : q))

        const inc = () =>
            setQuantity((q) => (q + stepQuantity <= maxAllowed ? q + stepQuantity : q))

        const plusDisabled = quantity + stepQuantity > maxAllowed
        const minusDisabled = quantity - stepQuantity < minOrderQuantity

        return (
            isVisible && (
                <Flex sx={containerStyle}>
                    <Button sx={minusButtonStyle} onClick={dec} isDisabled={minusDisabled}>
                        <MinusIcon sx={iconStyle} />
                    </Button>
                    <Text sx={inputStyle} as="span">
                        {quantity}
                    </Text>
                    <Button sx={plusButtonStyle} onClick={inc} isDisabled={plusDisabled}>
                        <AddIcon sx={iconStyle} />
                    </Button>
                </Flex>
            )
        )
    }

    QuantityPickerSection.propTypes = {
        quantity: PropTypes.number,
        minOrderQuantity: PropTypes.number,
        stockLevel: PropTypes.number,
        setQuantity: PropTypes.func,
        stepQuantity: PropTypes.number,
        isVisible: PropTypes.bool
    }

    const updateDeliceryType = (deliveryType) => {
        if (deliveryType === 'pickUpInStore') {
            setIsPickUpInStore(true)
        } else {
            setIsPickUpInStore(false)
        }
    }

    const PromotionsSection = ({promos = []}) => {
        const intl = useIntl()

        return (
            <VStack align="start" spacing={2} mt={4} width="100%">
                {promos.map(({id, details, calloutMessage}) => (
                    <Flex key={id} sx={flexStyle}>
                        {calloutMessage && (
                            <HStack sx={hStackStyle}>
                                <Box
                                    backgroundImage={`url(${getAssetUrl(
                                        'static/img/pdp/tagIcon.svg'
                                    )})`}
                                    sx={tagIconStyle}
                                />
                                <Box sx={calloutBoxStyle}>
                                    <span
                                        dangerouslySetInnerHTML={{
                                            __html: calloutMessage
                                        }}
                                    />
                                    {details && (
                                        <Tooltip label={details} sx={tooltipStyle}>
                                            <Text sx={desktopDetailsStyle} as="span">
                                                {intl.formatMessage({
                                                    id: 'pdp.promotions.details.details',
                                                    defaultMessage: 'DETAILS'
                                                })}
                                            </Text>
                                        </Tooltip>
                                    )}
                                </Box>
                            </HStack>
                        )}
                        {details && (
                            <Tooltip label={details} sx={tooltipStyle}>
                                <Text sx={mobileDetailsStyle}>
                                    {intl.formatMessage({
                                        id: 'pdp.promotions.details.details',
                                        defaultMessage: 'DETAILS'
                                    })}
                                </Text>
                            </Tooltip>
                        )}
                    </Flex>
                ))}
            </VStack>
        )
    }

    PromotionsSection.propTypes = {
        promos: PropTypes.array
    }

    const {
        variationParams,
        showLoading,
        variationAttributes,
        quantity,
        stockLevel,
        minOrderQuantity,
        setQuantity,
        stepQuantity,
        variant,
        isMaster,
        showInventoryMessage
    } = useDerivedProduct(productDetail, isProductASet, isProductABundle)
    const hasOrderableVariants = productDetail?.variants?.some((v) => v?.orderable)
    const isProductEffectivelyAvailable =
        productDetail?.c_isProductAvailable || (isMaster !== undefined && hasOrderableVariants)

    const {
        isOpen: isAddToCartModalOpen,
        onOpen: onAddToCartModalOpen,
        onClose: onAddToCartModalClose
    } = useAddToCartModalContext()

    const priceData = useMemo(() => {
        return getPriceData(productDetail, {quantity})
    }, [productDetail, quantity])

    const {formatMessage} = useIntl()
    const einstein = useEinstein()
    const navigate = useNavigation()
    const showToast = useToast()
    const toast = useToast()
    const {data: customer} = useCurrentCustomer()
    const {data: wishlist, isLoading: isWishlistLoading} = useWishList()
    const createCustomerProductListItem = useShopperCustomersMutation(
        'createCustomerProductListItem'
    )
    const {isLoading: isBasketLoading} = useCurrentBasket()
    const {isAtLimit, errorMessage: cartLimitErrorMessage} = useCartLimit()
    const [addToCartError, setAddToCartError] = useState('')
    const {addItemToNewOrExistingBasket} = useShopperBasketsMutationHelper()
    const customerId = useCustomerId()
    const {token} = useAccessToken()
    const {locale, site} = useMultiSite()
    const childProductRefs = React.useRef({})
    const comboProduct = isProductASet || isProductABundle ? normalizeSetBundleProduct(product) : {}

    let updateWishlist
    const [isItemWishlisted, setIsItemWishlisted] = useState(false)
    const [showOptionsMessage, toggleShowOptionsMessage] = useState(true)
    const [childProductOrderability] = useState({})
    const [childProductSelection] = useState({})
    const {shopperContext} = useUpdateShopperContext()
    const [storePickUp, setStorePickUp] = useState(
        product?.c_storepickup ? 'pickUpInStore' : 'shipToMe'
    )

    const errorContainerRef = useRef(null)
    const hasFired = useRef(false)

    const shopperStoreDetails = useMemo(() => {
        if (shopperContext?.customQualifiers?.storeDetails) {
            return JSON.parse(shopperContext?.customQualifiers?.storeDetails)
        }
        return null
    }, [shopperContext])

    const {disableButton} = useMemo(() => {
        let shouldDisableButton = showInventoryMessage
        let currentInventoryMsg = ''
        if (
            !shouldDisableButton &&
            (isProductASet || isProductABundle) &&
            childProductOrderability
        ) {
            // if any of the children are not orderable, it will disable the add to cart button
            const unavailableChildProductKey = Object.keys(childProductOrderability)?.find(
                (key) => {
                    return childProductOrderability[key].showInventoryMessage
                }
            )
            shouldDisableButton = !!unavailableChildProductKey
            if (unavailableChildProductKey) {
                const unavailableChildProduct = childProductOrderability[unavailableChildProductKey]
                if (unavailableChildProduct.unfulfillable) {
                    currentInventoryMsg = intl.formatMessage(
                        {
                            defaultMessage: 'Only {stockLevel} left for {productName}!',
                            id: 'use_product.message.inventory_remaining_for_product'
                        },
                        {
                            stockLevel: unavailableChildProduct.stockLevel,
                            productName: unavailableChildProduct.productName
                        }
                    )
                }
            }
        }
        return {disableButton: shouldDisableButton, customInventoryMessage: currentInventoryMsg}
    }, [showInventoryMessage, childProductOrderability])

    const handleModalClose = () => {
        navigate(location?.pathname + previousSearchParams)
        onClose()
    }

    const LowStockMessage = ({stockLevel}) => {
        const inStockValue = useSitePreference('inStockValue')
        const intl = useIntl()

        if (stockLevel > 0 && stockLevel < inStockValue?.data?.inStockValue) {
            return (
                <Text sx={stockLeftStyle} as="span">
                    {intl.formatMessage(
                        {
                            id: 'pdp.quantity.details.lowstock',
                            defaultMessage: 'In Stock – Only {stockLevel} left in stock'
                        },
                        {
                            stockLevel: stockLevel
                        }
                    )}
                </Text>
            )
        }
        return null
    }

    LowStockMessage.propTypes = {
        stockLevel: PropTypes.number
    }

    const handleAddToCart = async (productSelectionValues) => {
        try {
            const productItems = productSelectionValues?.map(
                ({variant, quantity, c_storeId, c_storepickup}) => ({
                    productId: variant.productId,
                    price: variant.price,
                    quantity,
                    c_storeId,
                    c_storepickup
                })
            )

            await addItemToNewOrExistingBasket(productItems)
            await getAdyenPaymentMethods(customerId, token, locale, site)

            // analytics: add to cart from quick view
            productSelectionValues.forEach(({product, quantity, c_storeId, c_storepickup}) => {
                triggerAddToCartEvent({
                    product,
                    qyt: quantity,
                    isInStorePickUp: c_storepickup || c_storeId ? true : false,
                    category,
                    usid
                })
            })

            einstein.sendAddToCart(productItems)

            // If the items were successfully added, set the return value to be used
            // by the add to cart modal.
            return productSelectionValues
        } catch (error) {
            let errorBody
            if (error?.response instanceof Response) {
                try {
                    errorBody = await error.response.clone().json()
                } catch {
                    const text = await error.response.text()
                    try {
                        errorBody = JSON.parse(text)
                    } catch {
                        errorBody = {message: text}
                    }
                }
            }

            if (errorBody?.statusCode === CART_LIMIT_ERROR_CODE) {
                // Cart is full - 24 product limit reached
                setAddToCartError(CART_FULL_ERROR_MESSAGE)
            } else if (errorBody?.statusCode === 'BUS-1001') {
                // Wishlist related error
                toast({
                    title: errorBody?.statusMessage,
                    status: 'info',
                    action: (
                        <Button
                            sx={viewLinkStyle}
                            variant="link"
                            onClick={() => navigate('/account/wishlist')}
                        >
                            {''}
                        </Button>
                    )
                })
            } else if (errorBody?.statusCode === 'SYS-1008') {
                toast({
                    title: errorBody?.statusMessage,
                    status: 'error'
                })
            } else {
                showError(error)
            }
        }
    }

    const handleAddToWishlist = (product, variant, quantity) => {
        const isItemInWishlist = wishlist?.customerProductListItems?.find(
            (i) => i.productId === variant?.productId || i.productId === product?.id
        )

        if (!isItemInWishlist) {
            createCustomerProductListItem.mutate(
                {
                    parameters: {
                        listId: wishlist.id,
                        customerId
                    },
                    body: {
                        // NOTE: API does not respect quantity, it always adds 1
                        quantity,
                        productId: variant?.productId || product?.id,
                        public: false,
                        priority: 1,
                        type: 'product'
                    }
                },
                {
                    onSuccess: () => {
                        toast({
                            title: formatMessage(TOAST_MESSAGE_ADDED_TO_WISHLIST, {quantity: 1}),
                            status: 'success',
                            action: (
                                // it would be better if we could use <Button as={Link}>
                                // but unfortunately the Link component is not compatible
                                // with Chakra Toast, since the ToastManager is rendered via portal
                                // and the toast doesn't have access to intl provider, which is a
                                // requirement of the Link component.
                                <Button
                                    sx={viewLinkStyle}
                                    variant="link"
                                    onClick={() => navigate('/account/wishlist')}
                                    // onClick={() => (window.location.href = '/wishlistpage/')}
                                >
                                    {formatMessage(TOAST_ACTION_VIEW_WISHLIST)}
                                </Button>
                            )
                        })

                        // analytics: add to cart from quick view
                        window.dataLayer.push({
                            action: 'Add to Wish List',
                            category: 'Product',
                            event: 'addToWishlistFromQuickView',
                            label: 'Quick View',
                            value: variant?.productId
                        })
                    },
                    onError: () => {
                        showError()
                    }
                }
            )
        } else {
            toast({
                title: formatMessage(TOAST_MESSAGE_ALREADY_IN_WISHLIST),
                status: 'info',
                action: (
                    <Button
                        sx={viewLinkStyle}
                        variant="link"
                        onClick={() => navigate('/account/wishlist')}
                        // onClick={() => (window.location.href = '/wishlistpage/')}
                    >
                        {formatMessage(TOAST_ACTION_VIEW_WISHLIST)}
                    </Button>
                )
            })
        }
    }

    const handleChildProductValidation = useCallback(() => {
        // Run validation for all child products. This will ensure the error
        // messages are shown.
        Object.values(childProductRefs.current).forEach(({validateOrderability}) => {
            validateOrderability({scrollErrorIntoView: false})
        })

        // Using ot state for which child products are selected, scroll to the first
        // one that isn't selected.
        const selectedProductIds = Object.keys(childProductSelection)
        const firstUnselectedProduct = comboProduct?.childProducts?.find(
            ({product: childProduct}) => !selectedProductIds.includes(childProduct.id)
        )?.product

        if (firstUnselectedProduct) {
            // Get the reference to the product view and scroll to it.
            const {ref} = childProductRefs.current[firstUnselectedProduct.id]

            if (ref.scrollIntoView) {
                ref.scrollIntoView({
                    behavior: 'smooth',
                    block: 'end'
                })
            }

            return false
        }

        return true
    }, [product, childProductSelection])

    const validateAndShowError = (opts = {}) => {
        const {scrollErrorIntoView = true} = opts
        // Validate that all attributes are selected before proceeding.
        const hasValidSelection = handleChildProductValidation(variant, quantity, stockLevel)
        const showError = !isProductASet && !isProductABundle && !hasValidSelection
        const scrollToError = showError && scrollErrorIntoView

        toggleShowOptionsMessage(showError)

        if (scrollToError) {
            errorContainerRef.current.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
            })
        }

        return hasValidSelection
    }

    const renderActionButtons = (isItemWishlisted) => {
        const buttons = []
        const buttonText = {
            update: intl.formatMessage({
                defaultMessage: 'Update Item',
                id: 'product_view.button.update'
            }),
            addToCart: intl.formatMessage({
                defaultMessage: 'Add to Cart',
                id: 'product_view.button.add_to_cart'
            }),
            addSetToCart: intl.formatMessage({
                defaultMessage: 'Add Set to Cart',
                id: 'product_view.button.add_set_to_cart'
            }),
            addBundleToCart: intl.formatMessage({
                defaultMessage: 'Add Bundle to Cart',
                id: 'product_view.button.add_bundle_to_cart'
            }),
            addToWishlist: intl.formatMessage({
                defaultMessage: 'Add to Wishlist',
                id: 'product_view.button.add_to_wishlist'
            }),
            addSetToWishlist: intl.formatMessage({
                defaultMessage: 'Add Set to Wishlist',
                id: 'product_view.button.add_set_to_wishlist'
            }),
            addBundleToWishlist: intl.formatMessage({
                defaultMessage: 'Add Bundle to Wishlist',
                id: 'product_view.button.add_bundle_to_wishlist'
            })
        }

        const handleCartItem = async () => {
            const hasValidSelection = validateAndShowError()
            const c_storeId = shopperStoreDetails?.id
            const c_storepickup = storePickUp === 'shipToMe' ? false : true

            if (!hasValidSelection) {
                return null
            }

            if (!handleAddToCart && !updateCart) return null

            if (updateCart) {
                await updateCart(variant || product, quantity, c_storeId, c_storepickup)
                return
            }
            try {
                const itemsAdded = await handleAddToCart([
                    {product: productDetail, variant, quantity, c_storeId, c_storepickup}
                ])
                // Open modal only when `addToCart` returns some data
                // It's possible that the item has been added to cart, but we don't want to open the modal.
                // See wishlist_primary_action for example.
                if (itemsAdded) {
                    onAddToCartModalOpen({
                        product,
                        itemsAdded,
                        selectedQuantity: quantity
                    })
                }
            } catch (e) {
                showError()
            }
        }

        const handleWishlistItem = async () => {
            //these changes are added to hybrid launch
            if (!customer.isRegistered) {
                const queryParams = Object.fromEntries(
                    new URLSearchParams(location.search).entries()
                )
                const url = new URL(productDetail.slugUrl, window.location.origin)
                const relativePath = url.pathname.replace('/s/Cavenders', '')
                const updatedUrl = rebuildPathWithParams(relativePath, queryParams)
                const pdpUrlParam = `/?original=${encodeURIComponent(updatedUrl)}`
                window.location.href = `/login${pdpUrlParam}`
            } else {
                if (!updateWishlist && !handleAddToWishlist) return null
                if (updateWishlist) {
                    updateWishlist(product, variant, quantity)
                    return
                }
                handleAddToWishlist(product, variant, quantity)
            }
        }

        // child product of bundles do not have add to wishlist button
        if ((handleAddToWishlist || updateWishlist) && !productDetail?.isProductPartOfBundle) {
            buttons.push(
                <Tooltip
                    sx={wishlistTooltip}
                    label={
                        isItemWishlisted
                            ? intl.formatMessage({defaultMessage: 'Already in Wishlist'})
                            : !showOptionsMessage
                            ? customer.isRegistered
                                ? intl.formatMessage({
                                      defaultMessage: 'Add to Wishlist'
                                  })
                                : intl.formatMessage({
                                      defaultMessage: 'Must be signed in to add to Wishlist'
                                  })
                            : intl.formatMessage({
                                  defaultMessage: 'Select Size to Add to Wishlist'
                              })
                    }
                    placement="bottom-start"
                    isDisabled={
                        isItemWishlisted || !showOptionsMessage
                            ? customer.isRegistered
                                ? false
                                : false
                            : false
                    }
                >
                    <span>
                        <Button
                            sx={wishlistButton}
                            key="wishlist-button"
                            onClick={handleWishlistItem}
                            isDisabled={
                                isWishlistLoading ||
                                !canAddToWishlist ||
                                showOptionsMessage ||
                                !isProductEffectivelyAvailable
                            }
                            isLoading={isWishlistLoading}
                            variant="outline"
                        >
                            {isItemWishlisted ? (
                                <Img
                                    sx={wishlistIcon}
                                    src={getAssetUrl('static/img/pdp/wishlistFilledIcon.png')}
                                />
                            ) : (
                                <Img
                                    sx={wishlistIcon}
                                    src={getAssetUrl('static/img/pdp/heartEmpty.png')}
                                />
                            )}
                        </Button>
                    </span>
                </Tooltip>
            )
        }

        // child product of bundles do not have add to cart button
        if ((handleAddToCart || updateCart) && !productDetail?.isProductPartOfBundle) {
            buttons.push(
                <Button
                    sx={addToCartButton}
                    key="cart-button"
                    onClick={handleCartItem}
                    isDisabled={
                        disableButton ||
                        showOptionsMessage ||
                        !isProductEffectivelyAvailable ||
                        (isAtLimit && !updateCart) // Only block for add to cart, not for update
                    }
                    isLoading={isBasketLoading}
                    variant="solid"
                >
                    {updateCart
                        ? buttonText.update
                        : isProductASet
                        ? buttonText.addSetToCart
                        : isProductABundle
                        ? buttonText.addBundleToCart
                        : buttonText.addToCart}
                </Button>
            )
        }

        return buttons
    }

    const {currency} = useCurrency()
    const [savingsCalc, setSavingsCalc] = useState()

    const {data} = useSitePreference('pdpVariationCategories, inStockValue')
    const pdpVariationCategory = data?.pdpVariationCategories
    const sizeMappingData = useSizeMappingData()

    useEffect(() => {
        if (wishlist && product && variant) {
            const isItemInWishlist = wishlist?.customerProductListItems?.find(
                (i) => i.productId === variant?.productId
            )
            setIsItemWishlisted(isItemInWishlist ? true : false)
        }
        return () => setIsItemWishlisted(false)
    }, [wishlist, variant, product])

    useEffect(() => {
        if (isAddToCartModalOpen) {
            onAddToCartModalClose()
        }
    }, [location.pathname])

    useEffect(() => {
        const saving =
            Math.floor(
                ((priceData?.listPrice - priceData?.currentPrice) / priceData?.listPrice) * 100
            ).toFixed() + '%'
        setSavingsCalc(saving)
    }, [priceData?.currentPrice, priceData?.listPrice])

    useEffect(() => {
        if (variant?.productId) {
            if (product && updateCart) {
                if (quantity === minOrderQuantity) {
                    setQuantity(product?.quantity)
                }
                if (
                    product.c_storepickup &&
                    productDetail?.c_instorePickupOnPWA?.enableInStorePickup &&
                    storePickUp !== 'shipToMe'
                ) {
                    setStorePickUp('pickUpInStore')
                    setIsPickUpInStore && setIsPickUpInStore(true)
                }
            } else {
                setQuantity(minOrderQuantity)
                if (isProductABundle) setSelectedBundleQuantity(minOrderQuantity)
            }
        }
    }, [variant?.productId, product, updateCart])

    useEffect(() => {
        if (variationAttributes?.length) {
            let flag = false
            variationAttributes?.forEach((attr) => {
                if (!attr?.selectedValue?.value) {
                    flag = true
                }
            })
            toggleShowOptionsMessage(flag)
        }
    }, [variationAttributes])

    // Set cart limit error message when cart is at 24 items (only for add to cart, not update)
    useEffect(() => {
        if (isAtLimit && !updateCart) {
            setAddToCartError(cartLimitErrorMessage)
        } else if (!addToCartError || addToCartError === cartLimitErrorMessage) {
            // Clear error only if it's the cart limit error
            setAddToCartError('')
        }
    }, [isAtLimit, cartLimitErrorMessage, updateCart])

    useEffect(() => {
        if (isAddToCartModalOpen) {
            onClose()
            let url = ''
            if (previousSearchParams) {
                url += location?.pathname + previousSearchParams
            } else {
                url += location?.pathname
            }
            navigate(url)
        }
    }, [isAddToCartModalOpen])

    useEffect(() => {
        if (!isOpen) return

        let selectDefault = !location?.search
        let url = location.pathname
        if (!selectDefault) {
            const params = new URLSearchParams(location?.search)
            // Check if any variation attribute is missing in the query string
            productDetail?.variationAttributes?.forEach((attr) => {
                if (!params.has(attr?.id)) {
                    selectDefault = true
                }
            })
        }

        if (selectDefault) {
            const paramsList = []
            productDetail?.variationAttributes?.forEach((attr) => {
                const orderableValues = attr?.values?.filter((value) => value?.orderable)
                if (orderableValues?.length === 1) {
                    paramsList.push(`${attr?.id}=${orderableValues[0]?.value}`)
                }
            })

            if (paramsList.length > 0) {
                const paramString = paramsList.join('&')
                if (previousSearchParams) {
                    url += previousSearchParams + '&' + paramString
                } else {
                    url += '?' + paramString
                }
            }
        }
        const updatedUrl = rebuildPathWithParams(`${url}${location.search}`, {
            pid: variant?.productId
        })

        history.replace(updatedUrl)
    }, [productDetail, isOpen, variant])

    useEffect(() => {
        if (
            productDetail?.type?.variant &&
            !productDetail?.c_instorePickupOnPWA?.enableInStorePickup
        ) {
            setStorePickUp('shipToMe')
            setIsPickUpInStore && setIsPickUpInStore(false)
        }
    }, [productDetail])

    // analytics: Quick View Open
    useEffect(() => {
        const isDataReady = window?.dataLayer
        if (!isDataReady) return
        window.dataLayer.push({
            action: 'Quick View Open',
            category: 'Product',
            event: 'quickViewSelected'
        })
    }, [])
    // analytics: product_group
    useEffect(() => {
        const isDataReady = window?.dataLayer && productDetail?.master?.masterId && priceData
        if (!isDataReady || hasFired.current) return
        hasFired.current = true // prevent future runs
        window.dataLayer.push({
            pageType: 'product_group',
            productID: productDetail?.master?.masterId,
            price: priceData?.currentPrice
        })
    }, [productDetail, priceData])

    const bazaarvoiceProductId = productDetail?.master?.masterId || productDetail?.id

    const bazaarvoiceReviews = bazaarvoiceProductId ? (
        <Stack>
            <Box
                data-bv-show="rating_summary"
                data-bv-product-id={bazaarvoiceProductId}
                width="100%"
            />
        </Stack>
    ) : null

    useEffect(() => {
        if (!isOpen || !bazaarvoiceProductId) {
            return
        }
        window.$BV?.ui?.refresh?.()
    }, [isOpen, bazaarvoiceProductId])

    // Allow Bazaarvoice submission modals (e.g. Write a review) to receive focus and input
    // while Quick View is open — Chakra's focus trap and overlay block BV otherwise.
    useEffect(() => {
        if (!isOpen) {
            return
        }

        const BV_SUBMISSION_MODAL_SELECTOR = [
            '[class*="bv-submission"]',
            '[class*="bv_submission"]',
            '.bv_modal_component_container',
            '[id*="bv"][role="dialog"]'
        ].join(', ')

        const syncBvModalLayering = () => {
            const bvSubmissionModal = document.querySelector(BV_SUBMISSION_MODAL_SELECTOR)
            document.querySelectorAll('.chakra-modal__overlay').forEach((overlay) => {
                if (bvSubmissionModal) {
                    overlay.style.pointerEvents = 'none'
                } else {
                    overlay.style.removeProperty('pointer-events')
                }
            })
        }

        const observer = new MutationObserver(syncBvModalLayering)
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'aria-hidden']
        })
        syncBvModalLayering()

        return () => {
            observer.disconnect()
            document.querySelectorAll('.chakra-modal__overlay').forEach((overlay) => {
                overlay.style.removeProperty('pointer-events')
            })
        }
    }, [isOpen])

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleModalClose}
            trapFocus={false}
            blockScrollOnMount={false}
            returnFocusOnClose={false}
        >
            <ModalOverlay />
            <ModalContent sx={modalContentStyle}>
                {isProductLoading && <LoadingSpinner wrapperStyles={{maxHeight: pxToRem(635)}} />}
                {isProductError && (
                    <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                        <Text>
                            {productError?.message ||
                                intl.formatMessage({
                                    id: 'error_loading_product',
                                    defaultMessage: 'Error loading product details.'
                                })}
                        </Text>
                    </Box>
                )}
                <ModalHeader sx={modalHeaderStyle}>
                    <IconButton
                        icon={
                            <img
                                src={getAssetUrl('static/img/modalCloseButton.png')}
                                height={isTabOrLarger ? '19' : '15'}
                                width={isTabOrLarger ? '19' : '15'}
                                alt="Cavender's"
                            />
                        }
                        variant="unstyled"
                        onClick={handleModalClose}
                    />
                </ModalHeader>
                <ModalBody overflow="hidden" p={{base: '11px', md: '30px'}}>
                    {!isProductLoading && !isProductError && (
                        <Box display={{base: 'block', md: 'flex'}}>
                            <Box
                                flex={{base: 'unset', md: 5}}
                                width={{base: '100%', md: 'auto'}}
                                sx={imageGalleryStyle}
                            >
                                {!isTabOrLarger && (
                                    <>
                                        <Box isLoaded={productDetail?.name}>
                                            <Heading
                                                sx={productTitle}
                                            >{`${productDetail?.name}`}</Heading>
                                        </Box>

                                        {bazaarvoiceReviews}

                                        {!productDetail?.isProductPartOfBundle && (
                                            <Box
                                                isLoaded={priceData?.currentPrice}
                                                marginBottom={pxToRem(25.51)}
                                            >
                                                {priceData?.currentPrice && (
                                                    <>
                                                        <DisplayPrice
                                                            priceData={priceData}
                                                            isPriceRange={
                                                                productDetail?.c_isPriceRange
                                                            }
                                                            currency={currency}
                                                            currentPriceProps={
                                                                priceData.isOnSale
                                                                    ? {
                                                                          ...priceStyle,
                                                                          ...salePriceStyle
                                                                      }
                                                                    : {...priceStyle}
                                                            }
                                                            listPriceProps={priceStyle}
                                                        />
                                                        {savingsCalc !== '0%' &&
                                                            savingsCalc &&
                                                            !productDetail?.c_isPriceRange && (
                                                                <Text sx={savingPriceStyle}>
                                                                    {savingsCalc}{' '}
                                                                    {intl.formatMessage({
                                                                        id: 'savings_percentage',
                                                                        defaultMessage: ` Savings`
                                                                    })}
                                                                </Text>
                                                            )}
                                                    </>
                                                )}
                                            </Box>
                                        )}
                                    </>
                                )}

                                <CloudinaryImageGallery
                                    size={'sm'}
                                    cloudinaryImageGallery={
                                        productDetail?.c_cloudinary
                                            ? productDetail.c_cloudinary
                                            : null
                                    }
                                    selectedVariationAttributes={variationParams}
                                    isProductSetOrBundle={isProductASet || isProductABundle}
                                    galleryOptionsDetail={galleryOptionsQuickView}
                                />
                            </Box>
                            <Box
                                sx={productDescriptionLayout}
                                flex={{base: 'unset', md: 7}}
                                width={{base: '100%', md: 'auto'}}
                            >
                                {isTabOrLarger && (
                                    <>
                                        <Box isLoaded={productDetail?.name}>
                                            <Heading
                                                sx={productTitle}
                                            >{`${productDetail?.name}`}</Heading>
                                        </Box>

                                        {bazaarvoiceReviews}

                                        {!productDetail?.isProductPartOfBundle && (
                                            <Box
                                                isLoaded={priceData?.currentPrice}
                                                marginBottom={pxToRem(25.51)}
                                            >
                                                {priceData?.currentPrice && (
                                                    <>
                                                        <DisplayPrice
                                                            priceData={priceData}
                                                            isPriceRange={
                                                                productDetail?.c_isPriceRange
                                                            }
                                                            currency={currency}
                                                            currentPriceProps={
                                                                priceData.isOnSale
                                                                    ? {
                                                                          ...priceStyle,
                                                                          ...salePriceStyle
                                                                      }
                                                                    : {...priceStyle}
                                                            }
                                                            listPriceProps={priceStyle}
                                                        />
                                                        {savingsCalc !== '0%' &&
                                                            savingsCalc &&
                                                            !productDetail?.c_isPriceRange && (
                                                                <Text sx={savingPriceStyle}>
                                                                    {savingsCalc}{' '}
                                                                    {intl.formatMessage({
                                                                        id: 'savings_percentage',
                                                                        defaultMessage: ` Savings`
                                                                    })}
                                                                </Text>
                                                            )}
                                                    </>
                                                )}
                                            </Box>
                                        )}
                                    </>
                                )}

                                {showLoading ? (
                                    <>
                                        <Box height={6} width={32} />
                                        <Box height={20} width={64} />

                                        <Box height={6} width={32} />
                                        <Box height={20} width={64} />
                                    </>
                                ) : (
                                    variationAttributes?.map(
                                        ({id, name, selectedValue, values}) => {
                                            const variationName = pdpVariationCategory?.includes(
                                                productDetail?.primaryCategoryId ||
                                                    productDetail?.c_primaryCatergoryID
                                            )
                                                ? name === 'Size'
                                                    ? intl.formatMessage({
                                                          id: 'pdp.variation.waist.label',
                                                          defaultMessage: 'Waist'
                                                      })
                                                    : name === 'Width'
                                                    ? intl.formatMessage({
                                                          id: 'pdp.variation.length.label',
                                                          defaultMessage: 'Length'
                                                      })
                                                    : name
                                                : name

                                            const swatches = values?.map(
                                                (
                                                    {href, name: swatchName, value, orderable},
                                                    index
                                                ) => {
                                                    const content =
                                                        sizeMappingData[swatchName] || swatchName
                                                    const hasSelection = Boolean(
                                                        selectedValue?.value
                                                    )
                                                    const isSelected =
                                                        selectedValue?.value === value
                                                    const isFirst = index === 0
                                                    const isFocusable =
                                                        isSelected || (!hasSelection && isFirst)

                                                    const hasOrderableVariant =
                                                        id === 'color' ||
                                                        productDetail?.variants?.some(
                                                            (variant) =>
                                                                variant?.variationValues[id] ===
                                                                    value && variant?.orderable
                                                        )
                                                    // Extract query string from href if present
                                                    const swatchQueryString =
                                                        href.includes('?') && href.split('?')[1]
                                                    let swatchHref
                                                    if (!previousSearchParams) {
                                                        swatchHref = `${
                                                            location.pathname.split('&')[0]
                                                        }?${swatchQueryString}`
                                                    } else {
                                                        swatchHref = `${location.pathname}${previousSearchParams}&${swatchQueryString}`
                                                    }
                                                    return (
                                                        <Swatch
                                                            key={value}
                                                            href={swatchHref}
                                                            disabled={
                                                                !orderable || !hasOrderableVariant
                                                            }
                                                            value={value}
                                                            name={swatchName}
                                                            variantName={variationName}
                                                            variant={
                                                                id === 'color' ? 'circle' : 'square'
                                                            }
                                                            selected={isSelected}
                                                            isFocusable={isFocusable}
                                                        >
                                                            {content}
                                                        </Swatch>
                                                    )
                                                }
                                            )
                                            return (
                                                <Box key={id} marginTop={pxToRem(25.51)}>
                                                    {id === 'color' ? (
                                                        values.length > 0 &&
                                                        values.map(({name: swatchName, value}) => (
                                                            <React.Fragment key={value}>
                                                                <Text sx={colorSwatchStyle}>
                                                                    <span>
                                                                        {intl.formatMessage({
                                                                            defaultMessage:
                                                                                'Color:',
                                                                            id: 'product_view.label.color'
                                                                        })}
                                                                    </span>{' '}
                                                                    <span>
                                                                        {swatchName &&
                                                                        typeof swatchName ===
                                                                            'string'
                                                                            ? swatchName
                                                                                  .split(' ')
                                                                                  .map(
                                                                                      (word) =>
                                                                                          word
                                                                                              .charAt(
                                                                                                  0
                                                                                              )
                                                                                              .toUpperCase() +
                                                                                          word
                                                                                              .slice(
                                                                                                  1
                                                                                              )
                                                                                              .toLowerCase()
                                                                                  )
                                                                                  .join(' ')
                                                                            : swatchName}
                                                                    </span>
                                                                </Text>
                                                                <CloudinaryImageSwatches
                                                                    cloudinaryImageGallery={
                                                                        productDetail?.c_cloudinary
                                                                            ? productDetail.c_cloudinary
                                                                            : null
                                                                    }
                                                                    value={value}
                                                                    showFallbackImage={true}
                                                                />
                                                            </React.Fragment>
                                                        ))
                                                    ) : (
                                                        <SwatchGroup
                                                            key={id}
                                                            c_sizeChart={productDetail?.c_sizeChart}
                                                            value={selectedValue?.value}
                                                            displayName={selectedValue?.name || ''}
                                                            label={intl.formatMessage(
                                                                {
                                                                    defaultMessage: '{variantType}',
                                                                    id: 'product_view.label.variant_type'
                                                                },
                                                                {variantType: variationName}
                                                            )}
                                                        >
                                                            {swatches}
                                                        </SwatchGroup>
                                                    )}
                                                </Box>
                                            )
                                        }
                                    )
                                )}
                                <DeliveryAddress
                                    product={productDetail}
                                    quantity={quantity}
                                    updateDeliceryType={updateDeliceryType}
                                    storePickUp={storePickUp}
                                    setStorePickUp={setStorePickUp}
                                    marginTop={pxToRem(16)}
                                    setQuantity={setQuantity}
                                    minOrderQuantity={minOrderQuantity}
                                />
                                {!isProductASet && !productDetail?.isProductPartOfBundle && (
                                    <HStack align="stretch" pt="10px">
                                        {productDetail?.c_isProductAvailable == undefined ||
                                        isMaster ? (
                                            <></>
                                        ) : isProductEffectivelyAvailable ? (
                                            <LowStockMessage stockLevel={stockLevel} />
                                        ) : (
                                            <Text sx={stockLeftStyle}>
                                                {intl.formatMessage({
                                                    id: 'pdp.quantity.details.outofstock',
                                                    defaultMessage: 'CURRENTLY OUT OF STOCK'
                                                })}
                                            </Text>
                                        )}
                                    </HStack>
                                )}

                                {!isProductASet && !productDetail?.isProductPartOfBundle && (
                                    <HStack sx={buttonContainer} marginTop={pxToRem(25.51)}>
                                        <Box sx={renderButtons}>
                                            {renderActionButtons(isItemWishlisted)}
                                            <QuantityPickerSection
                                                quantity={quantity}
                                                minOrderQuantity={minOrderQuantity}
                                                stockLevel={stockLevel}
                                                setQuantity={setQuantity}
                                                stepQuantity={stepQuantity}
                                                isVisible={
                                                    updateCart
                                                        ? true
                                                        : isProductEffectivelyAvailable
                                                }
                                            />
                                        </Box>
                                    </HStack>
                                )}

                                {addToCartError && (
                                    <HStack padding="10px" ml="-8px">
                                        <CartErrorMessage message={addToCartError} />
                                    </HStack>
                                )}

                                {!isProductASet && !productDetail?.isProductPartOfBundle && (
                                    <HStack align="stretch">
                                        <PromotionsSection
                                            promos={productDetail?.c_productPromotionsDetails}
                                        />
                                    </HStack>
                                )}
                            </Box>
                        </Box>
                    )}
                </ModalBody>
            </ModalContent>
        </Modal>
    )
}

QuickView.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    product: PropTypes.object,
    previousSearchParams: PropTypes.any,
    setSelectedBundleQuantity: PropTypes.func,
    updateCart: PropTypes.func,
    category: PropTypes.string
}

export default QuickView
